import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service'
import { WidgetConfiguration } from '@feature/widget-configs/models/widget-configuration';
import { AdditionalInformationWidgetConfiguration } from
  '../models/additional-information-widget-configuration';
import { UdfGroupResponseResult, UdfGroup } from '../models/UdfGroups';

@Injectable()
export class AdditionalInformationWidgetConfigurationHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService
  ) { }

  saveAdminConfiguration(widgetConfig: WidgetConfiguration, config: AdditionalInformationWidgetConfiguration): Observable<boolean> {
    const url = this
      .urlBuilder
      .getUrl('additional-information/config');
    const request = new SaveWidgetConfigurationRequest();
    request.WidgetConfiguration = widgetConfig;
    request.AdditionalInformationWidgetConfiguration = config;
    return this.http
      .post(url, request).pipe(
        map(res => true)
      );
  }

  getConfig(widgetConfigurationId: number): Observable<AdditionalInformationWidgetConfiguration> {
    const url = this
      .urlBuilder
      .getUrl(`additional-information/config/${widgetConfigurationId}`);
    

    return this
      .http
      .get<AdditionalInformationWidgetConfiguration>(url);
  }


  createCopyOfConfiguration(widgetConfig: WidgetConfiguration, config: AdditionalInformationWidgetConfiguration) {
    const url = this.urlBuilder.getUrl('additional-information/config/copy');
    const request = new SaveWidgetConfigurationRequest();
    request.WidgetConfiguration = widgetConfig;
    request.AdditionalInformationWidgetConfiguration = config;
    return this
      .http
      .post(url, request);
  }

  getSections(entityName: string): Observable<UdfGroup[]> {
    const url = this
      .urlBuilder
      .getUrl(`additional-information/sections/${entityName}`);


    return this
      .http
      .get<UdfGroupResponseResult>(url).pipe(map((response) => {
        return response.Groups;
      }));
  }

}


export class SaveWidgetConfigurationRequest {
  WidgetConfiguration: WidgetConfiguration;
  AdditionalInformationWidgetConfiguration: AdditionalInformationWidgetConfiguration;
}
